import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
// Brand-color overrides ride AFTER bootstrap so they win the cascade.
import "./styles/_brand-globals.scss";
import "./styles/_form-modal.scss";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RouteHandler from "./routes/route";
import store from "./store";
import { Provider } from "react-redux";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <ToastContainer />
        <RouteHandler />
      </Provider>
    </div>
  );
}

export default App;
